module.exports = __webpack_public_path__ + "static/media/curve.c3255008.svg";